import {gql} from '@apollo/client';

export const noteQueries = {
    GET_NOTE_BY_ID: gql`
        query GetNoteById($id: UUID!) {
            noteById(id: $id) {
                id
                description
                title
            }
        }
    `,
    GET_ALL_NOTES: gql`
        query GetAllNotes($after: String, $first: Int, $before: String, $last: Int, $where: NoteFilterInput) {
            allNotes(
                after: $after
                first: $first
                before: $before
                last: $last
                where: $where
                order: [{createdDate: DESC}]
            ) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    id
                    description
                    title
                    createdDate
                }
                pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                }
            }
        }
    `,
};
